import { AxiosResponseAndError, ResponseType } from '../types/axiosResponseType';
import { useMutation } from '@tanstack/react-query';
import ApiRequest from '../ApiRequest';
import { requestURLs } from '@/Environment';
// import { ResponseType } from 'axios';



type RemoveMemberResponseType = ResponseType<null>;

function useOrganisationRemoveMemberMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<RemoveMemberResponseType>["response"],
    AxiosResponseAndError<RemoveMemberResponseType>["error"],
    string[]
  >({
    mutationFn: (data) =>
      ApiRequest.delete<RemoveMemberResponseType>(
        `${requestURLs.organisation}/remove-members`, { data }
        
      ),
  });

  return mutation;
}

export default useOrganisationRemoveMemberMutation;